import { useNavigate } from "@tanstack/react-router";

export function PostVerdictSecondaryActions({ verdictId }: { verdictId: string }) {
  const navigate = useNavigate();

  const linkStyle: React.CSSProperties = {
    fontFamily: '"DM Mono", monospace',
    fontSize: 10,
    letterSpacing: 2,
    textTransform: "uppercase",
    color: "var(--smoke)",
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 0,
    transition: "color .2s",
  };

  return (
    <div
      data-testid="post-verdict-secondary"
      data-rp="secondary-actions"
      style={{
        marginTop: 48,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 24,
      }}
    >
      <button
        style={linkStyle}
        onClick={() => navigate({ to: "/verdict/$id", params: { id: verdictId } })}
        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--leather)")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--smoke)")}
      >
        Retour au verdict ↑
      </button>
      <span style={{ color: "var(--smoke)" }}>·</span>
      <button
        style={linkStyle}
        onClick={() => navigate({ to: "/archives" })}
        onMouseEnter={(e) => (e.currentTarget.style.color = "var(--leather)")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "var(--smoke)")}
      >
        Archiver cette séance →
      </button>
    </div>
  );
}

export default PostVerdictSecondaryActions;
